
import { DateRange, DayPicker } from "react-day-picker";
import { AssortGroup } from "../../../models/AssortGroup";
import "../../../../style/calendar.scss";
// import format from "date-fns/format";
import "../../../../style/block.scss";
import "./style.scss";
import useLocaleByLanguage from "../../../../utils/hooks/useLocaleByLanguage";
import { useTranslation } from "react-i18next";
import { addDays, format } from "date-fns";
import EADivider from "../../shared/EADivider";
import { useEffect, useState } from "react";
import EAAlert from "../../shared/EAAlert";
import useClubCart from "./hook/useClubCart";

interface IProps {
  item: AssortGroup;
  selectedDate: Date;
  setDateBetween: (date: Date) => void;
  ids: string;
}

const ClubPassRulesDesktop: React.FC<IProps> = ({ item, selectedDate, setDateBetween, ids }) => {
  const locale = useLocaleByLanguage();
  useEffect(() => {
    getClubCartDetails(`0,${item.objectId}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.objectId]);

  const { t } = useTranslation();

  const isPastDate = (date: Date | undefined): boolean => {
    return date ? date < new Date() : false;
  };

  const { getClubCartDetails, clubCarnetDetails, loading } = useClubCart();

  const [selectedDate2, setSelectedDate2] = useState<DateRange>({
    from: new Date("2020-02-22"),
    to: new Date("2020-02-22"),
  });
  const [messageAlert, setMessageAlert] = useState("");



  
  useEffect(() => {
    setSelectedDate2({
      from: clubCarnetDetails?.from ? new Date(clubCarnetDetails.from) : undefined,
      to: clubCarnetDetails?.to ? new Date(clubCarnetDetails.to) : undefined,
    });
  if(clubCarnetDetails?.first === false)
  setMessageAlert(`Ważność Twojej poprzedniej Karty Klubowej Imiennej FitPark Open na 2 miesiące skończyła się 
    (${clubCarnetDetails?.lastCard_validTo}). Zgodnie z zasadami prolongaty Oferty Specjalnej Twój nowy produkt zostanie skrócony o (${clubCarnetDetails?.daysBetween}) dni.`); 

  }, [clubCarnetDetails]);

  return (
    <>
    {(ids === "1241" || ids === '1243') &&
    
    <div className="calendar-pass">
     
      <div className="calendar-pass-calendar">
        {!loading && clubCarnetDetails ? (
          <>
            {clubCarnetDetails.first ? (
              <div className="calendar-pass_wrapper">
                {/* JEŚLI NIE MA KUPIONEGO */}
                <DayPicker

                  mode="single"
                  locale={locale}
                  selected={selectedDate}
                  fromDate={new Date()}
                  onSelect={(date) => {
                    setDateBetween(date ?? new Date());
                  }}
                  showOutsideDays
                  modifiersClassNames={{
                    selected: "my-selected",
                    today: "my-today",
                    range: "pass-range",
                  }}
                  modifiers={{ range: { from: selectedDate, to: addDays(selectedDate, item.dayValidate) } }}
                />

                <EAAlert
                  message="Drogi Kliencie, to będzie Twój pierwszy zakup Karty Klubowej Imiennej FitPark Open na 2 miesiące! Prosimy o zapoznanie się z zasadami prolongaty karnetu w przypadku kolejnych zakupów."
                  type="warning"
                  compact
                />
              </div>
            ) : (
              <div className="calendar-pass_wrapper">
                {/* JEŚLI  MA */}
                <DayPicker
                  mode="range"
                  locale={locale}
                  selected={{ from: selectedDate2.from, to: selectedDate2.to }} // Ustawienie zakresu
                  fromDate={new Date()}
                  showOutsideDays
                  modifiersClassNames={{
                    selected: "my-selected",
                    today: "my-today",
                  }}
                  disabled={[
                    ...(selectedDate2.from ? [{ before: selectedDate2.from }] : []), // Blokuje wybór przed datą początkową
                    ...(selectedDate2.to ? [{ after: selectedDate2.to }] : []), // Blokuje wybór po dacie końcowej
                  ]}
                />

                {isPastDate(selectedDate2.from) ? (
                  <>
                    <EAAlert
                      message={messageAlert}
                      type="error"
                    />
                  </>
                ) : (
                  <>
                    <EAAlert  message="Dziękujemy za kolejny zakup i przedłużenie ważności Twojej Karty Klubowej Imiennej FitPark Open na 2 miesiące w terminie! Do zobaczenia w klubie FitPark!" type="success" />
                  </>
                )}
              </div>
            )}
          </>
        ) : (
          <div className="calendar-pass_wrapper">
            {/* JEŚLI NIE MA KUPIONEGO */}
            <DayPicker
              mode="single"
              locale={locale}
              selected={selectedDate}
              fromDate={new Date()}
              onSelect={(date) => {
                setDateBetween(date ?? new Date());
              }}
              showOutsideDays
              modifiersClassNames={{
                selected: "my-selected",
                today: "my-today",
                range: "pass-range",
              }}
              modifiers={{ range: { from: selectedDate, to: addDays(selectedDate, item.dayValidate) } }}
            />

            {/* <EACheckbox
        name="clubCartAgreementt"
        checked={form?.clubCartAgreement}
        onChange={(value) => setForm({ ...form, clubCartAgreement: value })}
        label={
        
             <EAAlert
        message="Drogi Kliencie, to będzie Twój pierwszy zakup! Przed kontynuacją koniecznie zapoznaj się z zasadami Karnetu Klubowicza."
        type="warning"
        compact
      />
      
        }
      /> */}

            {/* Własny Checkbox */}
            <EAAlert
              message="Drogi Kliencie, to będzie Twój pierwszy zakup Karty Klubowej Imiennej FitPark Open na 2 miesiące! Prosimy o zapoznanie się z zasadami prolongaty karnetu w przypadku kolejnych zakupów.
"
              type="warning"
              compact
            />
          </div>
        )}
        {/* Jeśli nie ma wykupionego */}
        {}
      </div>

      <EADivider />

      <div className="calendar-pass-details">
        {!loading && clubCarnetDetails && (
          <>
            {clubCarnetDetails.first ? (
              <div className="flex-between-center">
                <span>{t("waznosc")}:</span>
                <b>
                  {format(selectedDate, "dd.MM.yyyy")} - {format(addDays(selectedDate, item.dayValidate), "dd.MM.yyyy")}
                </b>
              </div>
            ) : (
              <div className="flex-between-center">
                <span>{t("waznosc")}:</span>
                <b>
                  {selectedDate2.from && <>{format(selectedDate2.from, "dd.MM.yyyy")} </>}-
                  {selectedDate2.to && <>{format(selectedDate2.to, "dd.MM.yyyy")}</>}
                </b>
              </div>
            )}
          </>
        )}
      </div>
      <div className="flex-between-center">
        <span>{t("wartosc_karnetu")}:</span>
        <b>
          {" "}
          {item.price.toFixed(2)} {t("zl")}
        </b>
      </div>
    </div>
     }
  </>    
 
  );
};

export default ClubPassRulesDesktop;

